<template>
  <div class="fill-height bg pt-5">
    <v-container class="white narrow-container">
      <div class="pa-5">
        <div class="d-flex justify-space-between">
          <div class="display-1 mb-5">MESI CONFIGURATOR</div>
          <router-link :to="{ name: 'Home' }">Back to app</router-link>
        </div>
        <div class="title mb-5">Terms & Conditions</div>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
        </p>
        <p>
          Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?
        </p>
        <router-link :to="{ name: 'Home' }">Back to app</router-link>
      </div>
    </v-container>
  </div>
</template>

<script>
import { SUPPORTED_LOCALES } from '../locales/locales.js'

export default {
  name: 'Terms',
  jsonld () {
    const items = [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        type: 'https://configurator.mesimedical.com/terms-conditions'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Terms and conditions'
      }
    ]
    return {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': 'https://configurator.mesimedical.com/terms-conditions',
          url: 'https://configurator.mesimedical.com/terms-conditions',
          name: 'Start',
          inLanguage: SUPPORTED_LOCALES.find(el => el.code === this.$i18n.locale).iso,
          isPartOf: {
            '@type': 'WebSite',
            '@id': 'https://configurator.mesimedical.comt' + '/#website'
          },
          description: 'Terms and conditions',
          breadcrumb: {
            '@id': 'https://configurator.mesimedical.com/terms-conditions' + '/#breadcrumb'
          }
        },
        {
          '@type': 'BreadcrumbList',
          '@id': 'https://configurator.mesimedical.com/terms-conditions' + '/#breadcrumb',
          itemListElement: items
        }
      ]
    }
  },
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: 'Terms & Conditions'
  }
}
</script>

<style lang="scss" scoped>
.narrow-container {
  max-width: 800px;
}
</style>
